import React from 'react'
import { BrowserRouter,NavLink, Route, Routes } from 'react-router-dom';
import './App.css';
import Mouse from './components/mouse/snRNA';
import Rat from './components/rat/snRNA';
import Human from './components/human/snRNA';
const Home = () => <h1>Human Kidney Single Cell Transcriptome</h1>;
function App() {
  return (
    <BrowserRouter  basename={process.env.PUBLIC_URL}>
<div>
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/mouse'>mouse</NavLink>{' '}
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/rat'>rat</NavLink>{' '}
      <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to='/human'>human</NavLink>{' '}
      <Routes>
        <Route path="/mouse" element={<Mouse/>} />
        <Route path="/rat" element={<Rat/>} />
        <Route path="/human" element={<Human/>} />
        <Route render={() => <h1>Page not found</h1>} />
      </Routes>
</div>
</BrowserRouter>
  );
}
export default App;
